import { Action } from "~/modules/actions/Action";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getLogger, LoggerName } from "~/modules/logger";
import { CbmImpl } from "~/modules/cbm";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { getReservationsByTask, sendTrackingEvent } from "~/modules/actions/ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";



















export class LeaveConversationChannel implements Action<Promise<void>> {
    


    #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const logger = getLogger(context)(LoggerName.Actions);
        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();

        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const worker = taskRouter.worker;

        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        logger.debug(`leaveConversationChannel invoked with taskSid: ${this.#taskSid}`);

        const task = getReservationsByTask(worker, this.#taskSid)[0]?.task;

        if (!task) {
            const errorMsg = `leaveConversationChannel: Task not found for taskSid ${this.#taskSid}`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.LeaveConversationChannelCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const interactionSid = task.attributes.flexInteractionSid;
        const channelSid = task.attributes.flexInteractionChannelSid;

        if (!interactionSid) {
            const errorMsg = `leaveConversationChannel: Missing interactionSid for taskSid ${this.#taskSid}`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.LeaveConversationChannelCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        if (!channelSid) {
            const errorMsg = `leaveConversationChannel: Missing channelSid for taskSid ${this.#taskSid}`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.LeaveConversationChannelCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                interactionSid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        try {
            await cbm.leaveChannel(interactionSid, channelSid, "inactive", "closed");

            sendTrackingEvent(EVENTS.LeaveConversationChannelCompleted, analytics, worker, {
                taskSid: this.#taskSid,
                interactionSid,
                channelSid
            });

            return Promise.resolve();
        } catch (e) {
            const errorMsg = `leaveConversationChannel: Failed to leave conversation channel for taskSid ${
                this.#taskSid
            }`;
            logger.error(errorMsg);

            sendTrackingEvent(EVENTS.LeaveConversationChannelCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                interactionSid,
                channelSid
            });

            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
